import { Expose, Type } from 'class-transformer';
import { User } from '../../user/models';

export class AuthResponse {
  @Expose()
  public token: string;

  @Expose()
  @Type(() => User)
  public user: User;
}
